import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { GlobalContext, Section } from "../lib/Root";
import { useContext, useEffect, useState } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Box, Button, TextField } from '@mui/material';
import axios from "../lib/Axios";
import { z } from "zod";

//Define validation parameters required for each field.
var schema = z.object({ code: z.string().uuid({ message: "Invalid Code"}) });

export default function AccountOTC() {
	var _ = useContext(GlobalContext);
	window._ = _;

	useEffect(() => { _.document.title = "One Time Code"; }, []);

	useEffect(() => {
		if (!_.user.loading && _.user.id <= 0) { navigate("/account/login?local&redirect=/account/otc"); }
	}, [_.user.loading]);

	var [resending, setResending] = useState(false);
	var [success, setSuccess] = useState(false);
	var [searchParams, setSearchParams] = useSearchParams();
	var newuser = searchParams.has("new");
	var navigate = useNavigate();

	//Define hooks and handlers.
	var { register, handleSubmit, setError, formState: { errors, isSubmitting } } = useForm({
		resolver: zodResolver(schema)
	});

	//Function that gets the form data when submitted.
	var onSubmit = async (data) => {
		return axios.post("/account/otc", new URLSearchParams(data)).then(({ data }) => {
			if (!data || data.error) { throw new Error(!data ? "An unknown error occured." : data.error); }
			setSuccess(true);
		}).catch(e => {
			setError("root", { message: e.message });
		});
	};

	var resend = async (e) => {
		e.preventDefault();
		setResending("Verifying...");

		axios.get("/account/otc?resend").then(({ data }) => {
			if (data && data.error) { throw new Error(data.error); }
			setResending("New Code Sent!"); setTimeout(() => setResending(false), 5000);
		}).catch(e => {
			setError("root", { message: e.message });
			setResending("");
		});
	}

	if (success && newuser) {
		return <Section small center>
			<p>Your account as now been verified.</p>
			<Button onClick={() => navigate("/account")}>My Profile</Button>
		</Section>
	}

	//Output actual form.
	return <Section small center>
		{newuser && <p>Please check your email for your verification code.</p>}

		<Box component="form" onSubmit={handleSubmit(onSubmit)}>
			{errors.root && (<div className="notice">{errors.root.message}</div>)}
			<TextField {...register("code")} label="Code" autoComplete="off" error={!!errors.uuid} helperText={errors.uuid?.message} />
			<Button disabled={isSubmitting} type="submit">{isSubmitting ? "Verifying" : "Submit"}</Button>
			{resending === false && <span style={{ display: "block" }}>Need a new code? <Link onClick={(e) => resend(e)}>Resend Now</Link></span>}
			{resending && <span style={{ display: "block" }}>{resending}</span>}
		</Box>
	</Section>;
}